import React, { useEffect, useState } from "react";
import CnaeListPage from "../../../../../../presentation/pages/admin/cnae/list";
import { CNAESResponseModel } from "../../../../../../domain/models/cnae";
import { makeRemoteCNAES } from "../../../../usecases/cnaes/remote-cnaes-factory";
import { FilterType } from "../../../../../../presentation/pages/admin/cnae/list/type";
import { toastUtils } from "../../../../../../utils";

function MakeSolicitationList(): JSX.Element {
  const [list, setList] = useState<CNAESResponseModel>();
  const refFilters = React.useRef<FilterType>({});
  const [loading, setLoading] = useState<boolean>();

  const loadData = async (filters?: FilterType): Promise<void> => {
    try {
      setLoading(true);
      const response = await makeRemoteCNAES().load({
        ...filters,
      });
      setList(response);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  const handleReload = (filters: FilterType): void => {
    refFilters.current = filters;
    const aux = { ...refFilters.current, page: 0 || filters.page };
    Object.assign(aux, filters);
    refFilters.current = aux;
    loadData(aux);
  };

  const handleDelete = async (id: number): Promise<void> => {
    try {
      setLoading(true);
      await makeRemoteCNAES().delete(id);
      toastUtils.showMessage({
        type: "success",
        message: "Excluído com Sucesso!",
      });
      loadData(refFilters.current);
    } catch (error: any) {
      toastUtils.showMessage({
        type: "error",
        message: error?.userMessage || error?.detail,
      });
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <CnaeListPage
      list={list}
      loading={loading}
      handleReload={handleReload}
      handleDelete={handleDelete}
    />
  );
}

export default MakeSolicitationList;
